var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-autosuggest", {
    ref: "autosuggest",
    attrs: {
      suggestions: _vm.filteredOptions,
      "get-suggestion-value": function (s) {
        return s.item.nameWithCrs
      },
      limit: 5,
      "input-props": {
        class: "station-input " + _vm.extraClasses,
        placeholder: _vm.placeholder,
        ref: "input",
      },
    },
    on: {
      keydown: function ($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
        ) {
          return null
        }
        return _vm.onTab($event)
      },
      input: _vm.onInputChange,
      focus: _vm.onFocus,
      selected: _vm.onSelected,
      blur: _vm.blur,
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var suggestion = ref.suggestion
          return [
            _c(
              "span",
              {
                staticClass: "autosuggest__results-item-tabtarget w-100 h-100",
                attrs: { tabindex: "-1" },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(suggestion.item.nameWithCrs) +
                    "\n        "
                ),
              ]
            ),
          ]
        },
      },
    ]),
    model: {
      value: _vm.selectedItem,
      callback: function ($$v) {
        _vm.selectedItem = $$v
      },
      expression: "selectedItem",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }